module.exports = __webpack_public_path__ + "media/images/emblems/Hermrigen-coat_of_arms-06110690c19eff7fb300843faec2e20c.svg";